<template>
    <div class="newsSecondPage3">
        <div class="newsbox">
            <!-- <img src="@/assets/imgs/train/courseimg1.png" @click="goleadFn" class="goleadFn" /> -->
            <!-- <div class="Courseimg" @click="goleadFn">
                <img src="@/assets/imgs/train/courseimg1.png" />

            </div> -->
            <div class="Courseimg">
                <img src="@/assets/imgs/train/courseimg2.png" />
                <div class="textbox">暂未开课</div>
            </div>
            <div class="Courseimg">
                <img src="@/assets/imgs/train/courseimg3.png" />
                <div class="textbox">暂未开课</div>
            </div>
            <div class="Courseimg">
                <img src="@/assets/imgs/train/courseimg4.png" />
                <div class="textbox">暂未开课</div>
            </div>
        </div>
        <!-- <div class="newsbox" v-if="dataList.length!==0">
            <div class="leftImgRightTextBox">
                <div v-for="(item,index) in dataList" :key="index" class="itemBox" @click="goNewsDetailFn(item)">
                    <img :src="srcUrl+item.titleImgUrl" class="imgbox" />
                    <div class="contentbox">
                        <div class="title overflowone">{{item.pressTopic}}</div>
                        <div class="synopsis overflowtwo">{{item.synopsis}}</div>
                        <div class="time">{{item.pressTime | timer}}</div>
                    </div>
                </div>
            </div>
            <div class="pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                    :page-sizes="[5, 10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <div class="emptyBox" v-else>
			<img src="@/assets/imgs/home/emptyimg.png" />
		</div> -->
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
    },
    data() {
        return {
            srcUrl: srcUrl,
            currentPage: 1,
            total: 10,
            pageSize: 10,
            dataList: []
        }
    },
    created() {
        this.getNews()
    },
    methods: {
        async getNews() {
            let params = {
                pageSize: this.pageSize,
                pageCurrent: this.currentPage,
                pressSuperClass: 29,
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.dataList = data.result.list
                this.total = data.result.total;
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getNews();
        },
        handleCurrentChange(val) {
            // this.pageSize = 1;
            this.currentPage = val;
            this.getNews();
        },
        goNewsDetailFn(val) {
            this.$router.push({
                path: "/news-detail",
                query: {
                    id: val.pressId,
                },
            });
        },
        goleadFn() {
            this.$router.push('/leade-talent');
        }
    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.newsSecondPage3 {
	// min-height: 500px;
	width: 1200px;
	padding-bottom: 20px;
	.newsbox {
		// max-height: 860px;
		min-height: 460px;
		position: relative;
		display: flex;
		flex-direction: row;
		.pagination-box {
			position: absolute;
			bottom: -60px;
			left: 50%;
			transform: translateX(-50%);
		}
		.leftImgRightTextBox {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			.itemBox {
				display: flex;
				flex-direction: row;
				margin: 0 48px 50px 0;
				width: 48%;
				cursor: pointer;
				&:nth-child(2n) {
					margin-right: 0;
				}
			}
		}
		.Courseimg {
			width: 286px;
			height: 228px;
			// border: 1px solid red;
			margin-right: 20px;
			cursor: pointer;
			position: relative;
			img {
				width: 100%;
				height: 100%;
			}
			&:last-child {
				margin-right: 0px;
			}
			.textbox {
				width: 286px;
				height: 228px;
				position: absolute;
				top: 0;
				left: 0;
				// transform: translateX(-50%);
				background: rgba(0, 0, 0, 0.5);
				color: #fff;
				text-align: center;
				line-height: 228px;
				cursor: auto;
			}
		}
	}
}
</style>


